import { InputField, LabelField } from 'components';
import { DateTimePickerField } from 'components/DateTime/DateTimePicker';
import { HintField } from 'components/HintField';
import Selection from 'components/Selection/Selection';
import { getDateFormat, getDateFormatForDatePicket, maskDate } from 'helper';
import { useSearch } from 'hook/useSearch';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { toastr } from 'react-redux-toastr';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import Wysiwyg from '../../Classes/newClassSteps/ClassInformation/Wysiwyg';
import BulkClassUploadCoverImage from './BulkClassUploadCoverImage';
import { fontConfig } from "theme/fontConfig";

const BulkClassInfoFields = ({ formik, coverImage, setCoverImage, handleOpenCoverImage, croppedImage, classesList, getClassesLoading }) => {
  const dateMask = maskDate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(getDateFormatForDatePicket());
  const minDate = new Date();

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }


  return (
    <>
      <Row>
        <Col className="col-sm-12">
          <InputField
            titleStyle={{
              fontFamily: fontConfig.GeneralInputFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
            mandatory={true}
            {...{
              formik,
              title: 'Bulk Registration Name',
              name: 'bulkName',
              placeholder: 'Bulk Registration Name',
              checkValidation: true,
            }}
            value={formik.values?.bulkName}
            handleChange={(e) => {
              const val = e.target?.value;
              if (val.length > 30) return;
              formik.setFieldValue('bulkName', val);
              if (!val) {
                formik.setFieldError('bulkName', 'Required');
                formik.setFieldTouched('bulkName', true, false);
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
              if (e.key === ' ' && formik.values?.bulkName === '') {
                e.preventDefault();
              }
            }}
          />
        </Col>
      </Row>
      <Row className="align-items-baseline">
        <Col className="col-sm-6 bulk-registration-starts" style={{ marginTop: '40px' }}>
          <LabelField
            title={'Bulk Registration Starts'}
            mandatory
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <div className={`form-group fv-plugins-icon-container mb-0`}>
            <DatePicker
              isClearable
              showIcon
              placeholderText={getDateFormat()}
              dateFormat={getDateFormatForDatePicket()}
              selected={
                formik.values?.bulkStartDate &&
                convertUTCToLocalDate(formik.values?.bulkStartDate)
              }
              onChange={(e) => {
                if (!e) {
                  formik.setFieldValue('bulkStartDate', null);
                  formik.setFieldError('bulkStartDate', 'Required');
                  formik.setFieldTouched('bulkStartDate', true, false);
                  return;
                }
                if (formik.values?.bulkEndDate && e > formik.values?.bulkEndDate) {
                  toastr.info('Validation', 'Registration Starts date should be less than Registration Ends date');
                  return;
                }
                formik.setFieldValue(`bulkStartDate`, e);
                convertLocalToUTCDate(e, `bulkStartDate`);
              }}
              minDate={minDate}
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={dateMask}
                  keepCharPositions={true}
                  guide={true}
                  className={`form-control${formik.touched?.bulkStartDate && formik.errors?.bulkStartDate ? ' is-invalid' : ''}`}
                />
              }
            />
            {formik.touched?.bulkStartDate && formik.errors?.bulkStartDate && (
              <HintField error={formik.errors.bulkStartDate} />
            )}
          </div>
        </Col>
        <Col className="col-sm-6" style={{ marginTop: '40px' }}>
          <DateTimePickerField
            mandatory={true}
            {...{
              formik,
              title: 'Bulk Registration Ends',
              name: 'bulkEndDate',
            }}
            checkValidation={true}
            placeholderText={getDateFormat()}
            dateFormat={getDateFormatForDatePicket()}
            selected={
              formik.values?.bulkEndDate &&
              convertUTCToLocalDate(formik.values?.bulkEndDate)
            }
            onChange={(e) => {
              if (!e) {
                formik.setFieldValue('bulkEndDate', null);
                formik.setFieldError('bulkEndDate', 'Required');
                formik.setFieldTouched('bulkEndDate', true, false);
                return;
              }
              formik.setFieldValue(`bulkEndDate`, e);
              convertLocalToUTCDate(e, `bulkEndDate`);
            }}
            disabled={
              !formik.values?.bulkStartDate ||
              formik.values?.alwaysAvailable
            }
            minDate={new Date(formik.values?.bulkStartDate) || minDate}
          />
        </Col>
      </Row>
      <Row>
      <Col className="col-sm-12" style={{ marginTop: '20px' }}>
        <LabelField title={"Classes"} mandatory={true}/>
        <Selection
					name="classes"
					mandatory={true}
					placeholder="Select Classes"
					options={classesList}
					isLoading={getClassesLoading}
					onChange={(value) => {
						if (!value || value.length === 0) {
							formik.setFieldValue('classes', []);
							formik.setFieldError('classes', 'Required');
							formik.setFieldTouched('classes', true, false);
							return;
						}
            formik.setFieldValue('classes', value.map((item) => item.value));
					}}
					value={classesList?.filter((item) => formik.values?.classes?.includes(item.value))}
					isClearable={false}
          isMulti={true}
          style={"secondary"}
				/>
        {formik.touched?.classes && formik.errors?.classes && (
          <HintField error={typeof formik.errors.classes === 'string' ? formik.errors.classes : 'Required'} />
        )}
      </Col>
      </Row>
      <Row>
        <Col className="col-sm-12" style={{ marginTop: '40px' }}>
          <LabelField
            title="Description"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <Wysiwyg formik={formik} />
        </Col>
      </Row>
      <Row>
        <Col className="col-sm-12" style={{ marginTop: '40px' }}>
          <LabelField
            title="Upload Cover Image (Max allowed is 5MB) (Min Image Dimension: 800x800)"
            style={{
              fontFamily: fontConfig.GeneralLabelFieldFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          <BulkClassUploadCoverImage
            coverImageFile={coverImage?.name}
            handleOpenCoverImage={handleOpenCoverImage}
            croppedImage={croppedImage}
          />
        </Col>
      </Row>
    </>
  )
}

export default BulkClassInfoFields